import styled from 'styled-components';
import CustomButton from '../atoms/CustomButton';

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
`;

export const SalesButton = styled(CustomButton)`
  &:hover {
    color: #1890ff;
  }
  &:focus {
    color: #096dd9;
  }
`;
